var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommissionDuedatetimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.8,
    viewBox: "0 0 24 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bills-solid",
    d: "M3.6,34.4v8.4A2.4,2.4,0,0,0,6,45.2H21.6A2.4,2.4,0,0,0,24,42.8V34.4A2.4,2.4,0,0,0,21.6,32H6A2.4,2.4,0,0,0,3.6,34.4Zm2.4,6a2.4,2.4,0,0,1,2.4,2.4H6Zm2.4-6A2.4,2.4,0,0,1,6,36.8V34.4Zm13.2,6v2.4H19.2A2.4,2.4,0,0,1,21.6,40.4Zm-2.4-6h2.4v2.4A2.4,2.4,0,0,1,19.2,34.4Zm-8.4,4.2a3,3,0,1,1,3,3A3,3,0,0,1,10.8,38.6Zm-9-3.3a.9.9,0,1,0-1.8,0v9a4.5,4.5,0,0,0,4.5,4.5h15a.9.9,0,1,0,0-1.8H4.5a2.7,2.7,0,0,1-2.7-2.7Z",
    transform: "translate(0 -32)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionDuedatetimeIcon);
export default __webpack_public_path__ + "static/media/commission-duedatetime-icon.3f5e9bc149f9f0d886151b49c4bbd2ad.svg";
export { ForwardRef as ReactComponent };